import { Injectable, EventEmitter } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AudioService extends BaseService {
  activeAudios = [];
  audioEmitter = new EventEmitter();
  private audioObserver: Subject<any> = new Subject<any>();

  constructor(protected http: HttpClient) {
    super();
  }

  public addAudio(id: number) {
    if (this.activeAudios.length > 0) {
      this.activeAudios.forEach(id => {
        this.audioObserver.next(id);
      });
    }
    const exists = this.activeAudios.find(el => el === id);
    if (!exists) {
      this.activeAudios.push(id);
    }
  }

  public stopAudioListener() {
   return this.audioObserver.asObservable();
  }

}
